const widgetEllipsis = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.833 9.167a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667m4.167 0A1.333 1.333 0 1 1 8 6.5a1.333 1.333 0 0 1 0 2.667m4.167 0a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667"/></svg>',
};

export { widgetEllipsis as default };
